import React, { useState, useEffect, useCallback } from "react";
import styles from "./ERPTable.module.css";
import Pagination from "./Pagination";
import { getPayableListing } from "../../../Bookclosure/Services/ApiHandler";

const ERPDataTable = ({ PayableID }) => {
  const [data, setData] = useState([]);
  const [columns, setColumns] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(30);
  const [totalPages, setTotalPages] = useState(1);

  const formatHeading = (text) =>
    text
      .replace(/([A-Z]+)([A-Z][a-z])/g, "$1 $2")
      .replace(/([a-z])([A-Z])/g, "$1 $2")
      .trim();

  const loadData = useCallback(async () => {
    if (!PayableID) return;
    try {
      const response = await getPayableListing(PayableID, {
        page: currentPage,
        pageSize: rowsPerPage,
        filters: [],
      });

      const res = response.data;
      const fetchedData = res.payableListing || [];
      const headers =
        res.payableListingHeaders && res.payableListingHeaders.length > 0
          ? res.payableListingHeaders
          : fetchedData.length > 0
          ? Object.keys(fetchedData[0]).filter((k) => !k.startsWith("_"))
          : [
              "Invoice No",
              "Company",
              "Vendor / Supplier",
              "Posting Date",
              "Bill No",
              "Currency",
              "Net Total",
              "Taxes & Charges",
              "Grand Total",
              "Outstanding Amount",
              "Status",
            ];

      setColumns(headers);
      setData(fetchedData);

      if (fetchedData.length > rowsPerPage || res.totalPages === 1) {
        setTotalPages(Math.ceil(fetchedData.length / rowsPerPage) || 1);
      } else {
        setTotalPages(res.totalPages || 1);
      }
    } catch (err) {
      console.error("Failed to fetch ERP payables table data:", err);
    }
  }, [PayableID, currentPage, rowsPerPage]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.tableContainer}>
        <div className={styles.tableWrapper}>
          <table className={styles.table}>
            <thead>
              <tr>
                {columns.map((col, index) => (
                  <th key={col || index} className={styles.tableHeader}>
                    {formatHeading(col)}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan={columns.length || 1}
                    style={{ textAlign: "center", padding: "32px", color: "#777" }}
                  >
                    No ERP records found.
                  </td>
                </tr>
              ) : (
                (data.length > rowsPerPage
                  ? data.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage)
                  : data
                ).map((row, i) => (
                  <tr key={i} className={styles.tableRow}>
                    {columns.map((col, j) => (
                      <td key={col || j} className={styles.tableCell}>
                        {row[col] !== undefined && row[col] !== null
                          ? typeof row[col] === "object"
                            ? JSON.stringify(row[col])
                            : String(row[col])
                          : "-"}
                      </td>
                    ))}
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <div className={styles.paginationWrapper}>
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          rowsPerPage={rowsPerPage}
          onPageChange={setCurrentPage}
          onRowsPerPageChange={(rows) => {
            setRowsPerPage(rows);
            setCurrentPage(1);
          }}
        />
      </div>
    </div>
  );
};

export default ERPDataTable;
